import { render, staticRenderFns } from "./AttendWithGuestsDialog.vue?vue&type=template&id=4fbcfbac"
import script from "./AttendWithGuestsDialog.vue?vue&type=script&lang=ts"
export * from "./AttendWithGuestsDialog.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports